module.exports = __webpack_public_path__ + "img/icon_doctor.1b425a71.svg";